import { yup } from '@framework/validation';
import { evaluateExpression } from '../../../../expressions/evaluate/evaluateExpression';
import { IConditionGroupExpression } from '../../../../expressions/repository/condition-group/IConditionGroupExpression';
import { IParentWidgetScope } from '../../../IWidgetType';
import { setComputeTransform } from '../setComputedTransform';

export function setComputedBooleanTransform(
  widget: { expression: IConditionGroupExpression },
  parentScope: IParentWidgetScope,
  schema: yup.AnySchema,
) {
  return setComputeTransform(
    widget.expression,
    parentScope,
    schema,
    (expression, variables) => {
      return evaluateExpression(expression, { variables });
    },
  );
}
